import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import navStyles from "../styles/Navbar.module.css";

const menuItem = [
  {
    id: 1,
    name: "Packages",
    link: "/plus",
  },
  {
    id: 2,
    name: "Channels",
    link: "/plus/channels",
  },
  {
    id: 3,
    name: "Instructions",
    link: "/plus/instructions",
  },
  {
    id: 4,
    name: "ISPs/MDUs",
    link: "/plus/isps-mdus",
  },
  {
    id: 5,
    name: "Sign Up",
    link: "/plus/signup",
  },
];

const Navbar = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box sx={{ px: 2 }}>
      <Box sx={{ textAlign: "right", mt: 2 }}>
        <IconButton
          color="inherit"
          edge="end"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, color: "#fff" }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ py: { xs: 2, md: 4 }, px: 2, mt: { xs: 2, md: 4 } }}>
        <nav
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16, //isMobile ? 5 : 16,
          }}
        >
          {menuItem.map((menu) => (
            <NavLink
              key={menu?.id}
              className={(navInfo) =>
                navInfo.isActive ? navStyles.navLinkActive : navStyles.navLink
              }
              to={menu?.link}
              onClick={handleDrawerToggle}
              end
            >
              <span>{menu?.name}</span>
            </NavLink>
          ))}
        </nav>
      </Box>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div>
      <Box sx={{ display: "flex", boxShadow: 0, mt: { xs: 2, md: 4 } }}>
        <AppBar
          className={navStyles.navBar}
          position="fixed"
          sx={{ boxShadow: 0, border: 0 }}
        >
          <Toolbar
            sx={{
              alignItems: "center",
              padding: "0px !important",
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // px: { xs: 1, sm: 0, md: 1, lg: 3, xl: 4 },
                px: 4,
                my: 2,
              }}
            >
              <Link className={navStyles.logo} to="/">
                <img
                  src={"/assets/images/logo.png"}
                  alt="SivooTV+"
                  width={"100%"}
                  height={isMobile ? 30 : 40}
                />
              </Link>
              <Box
                sx={{
                  display: { xs: "none", md: "block" },
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: { xs: 0.2, md: 4 },
                  marginLeft: "auto",
                }}
              >
                <Box
                  component="nav"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 2,
                  }}
                >
                  {menuItem.map((menu) => (
                    <>
                      <NavLink
                        key={menu?.id}
                        className={(navInfo) =>
                          navInfo.isActive
                            ? navStyles.navLinkActive
                            : navStyles.navLink
                        }
                        to={menu?.link}
                        end
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.1,
                          }}
                          variant="span"
                        >
                          {menu?.name}
                        </Typography>
                      </NavLink>
                    </>
                  ))}
                </Box>
              </Box>
              <Box sx={{ display: { md: "none" } }}>
                <IconButton
                  color="inherit"
                  edge="end"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 1 }}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        <Box
          component="nav"
          sx={{ flexShrink: { sm: 0 } }}
          className={navStyles.sideDrawer}
        >
          <Drawer
            container={container}
            variant="temporary"
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", md: "none" },
              zIndex: 99999,
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: { xs: "50%", md: "25%" },
                bgcolor: "#25262C",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
      </Box>
    </div>
  );
};

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
